import React from "react";
import NoContentIcon from "../../../../assets/icons/NoContent.jsx";
import { NoContentDescription, NoContentTitle, NoContentWrapper } from "./elements.js";

const NoContent = ({ title, description, translate, noBackground }) => {
	return (
		<NoContentWrapper noBackground={noBackground}>
			<NoContentIcon />
			<NoContentTitle>{translate(title)}</NoContentTitle>
			<NoContentDescription>{translate(description)}</NoContentDescription>
		</NoContentWrapper>
	);
};

export default NoContent;
